import React from "react";

const IncomeTax = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M23.438 8.064h5.453c-.987-.989-4.371-4.37-5.453-5.448v5.448zM33.062 15.935H2.937a.938.938 0 00-.937.937v10.25c0 .518.42.938.937.938h30.125c.518 0 .938-.42.938-.938v-10.25a.937.937 0 00-.938-.937zm-20.562 3.5h-1.563v6.062a.937.937 0 11-1.875 0v-6.062H7.5a.938.938 0 010-1.875h5a.937.937 0 110 1.875zm8.58 6.94a.937.937 0 01-1.208-.548l-.335-.892h-3.072l-.338.894a.938.938 0 01-1.754-.663c2.73-7.219 2.612-6.905 2.62-6.924.169-.415.569-.682 1.016-.682.475 0 .876.3 1.027.708l2.591 6.9a.938.938 0 01-.547 1.207zm7.42.06a.936.936 0 01-.763-.393L26 23.61l-1.737 2.432a.937.937 0 01-.764.393c-.754 0-1.207-.86-.762-1.483l2.11-2.955-2.11-2.955a.938.938 0 011.526-1.09L26 20.384l1.737-2.432a.938.938 0 011.526 1.09l-2.111 2.955 2.11 2.955c.446.624-.008 1.483-.761 1.483zM6.561 32.125c0 1.034.841 1.875 1.875 1.875h19.125a1.877 1.877 0 001.875-1.875v-2.187H6.561v2.187z"
            fill={fill}
        />
        <path
            className="u_fill"
            d="M29.437 9.938H22.5A.937.937 0 0121.562 9V2H8.437c-1.033 0-1.874.904-1.874 1.938v10.125h22.874V9.938zm-13.437 2h-4.5a.938.938 0 010-1.875H16a.937.937 0 110 1.875zm0-4h-4.5a.937.937 0 110-1.875H16a.937.937 0 110 1.875zM17.174 23.061h1.659l-.826-2.2-.833 2.2z"
            fill={fill}
        />
    </svg>
);
export default IncomeTax;
